import { Link } from 'react-router-dom'

export function UnauthorizedPage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-muted">
			<div className="text-center max-w-md">
				<div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
					<svg className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
						/>
					</svg>
				</div>
				<h1 className="text-2xl font-bold text-foreground">Session Expired</h1>
				<p className="mt-3 text-muted-foreground">Your session has expired. Please log in again.</p>
				<Link
					to="/login"
					className="mt-6 inline-block px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
				>
					Log In
				</Link>
			</div>
		</div>
	)
}
